export default "__VITE_ASSET__CNevFRXh__"